const o = (t) => /\d$/.test(t.toString()) ? `${parseFloat(t.toString())}px` : t.toString();
export {
  o as suffixPx
};
//# sourceMappingURL=suffixPx.mjs.map
